import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w50 pd-lt-7 chart-box" }
const _hoisted_2 = { class: "total-ticket-chart" }
const _hoisted_3 = { class: "chart-top" }
const _hoisted_4 = { class: "chart-top-lt" }
const _hoisted_5 = { class: "chart-tabs" }
const _hoisted_6 = {
  class: "nav",
  id: "myTab",
  role: "tablist"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = {
  class: "nav-link active",
  id: "home-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#home",
  type: "button",
  role: "tab",
  "aria-controls": "home",
  "aria-selected": "true"
}
const _hoisted_9 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_10 = {
  class: "nav-link",
  id: "profile-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#profile",
  type: "button",
  role: "tab",
  "aria-controls": "profile",
  "aria-selected": "false"
}
const _hoisted_11 = {
  key: 0,
  class: "chart-top-rt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.constants.TICKET_STATUS_BUTTON), 1)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.constants.TESTCASE_EXECUTION_REPORT_BUTTON), 1)
              ])
            ])
          ])
        ]),
        (!_ctx.isProjectDetailsMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "chart-select" }, [
                _createElementVNode("select", {
                  class: "v1-selectbox",
                  id: "jiraWBT"
                })
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "chart-btm tab-content",
        id: "myTabContent"
      }, [
        _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "home",
          role: "tabpanel",
          "aria-labelledby": "home-tab"
        }, [
          _createElementVNode("div", { class: "chart-show-img" })
        ]),
        _createElementVNode("div", {
          class: "tab-pane fade",
          id: "profile",
          role: "tabpanel",
          "aria-labelledby": "profile-tab"
        }, [
          _createElementVNode("div", { class: "chart-show-img" })
        ])
      ], -1))
    ])
  ]))
}